import React, { useEffect } from 'react'
import Loader from './Loader'
const FullPageLoader = ({ loading, message }) => {
    useEffect(() => {
        document.body.classList.toggle('no-scroll', loading)
        return () => {
            document.body.classList.remove('no-scroll')
        }
    }, [loading])

    if (!loading) return null

    return (
        <div className="overlay">
            <div className="overlay__content">
                <Loader />
                {message && <p className="overlay__message">{message}</p>}
            </div>
        </div>
    )
}

export default FullPageLoader
